import axios from "axios";

export const uploadImage = async ({ body, setLoading, setLink }) => {
  try {
    const { data } = await axios.post(
      `https://healthywalidiwali.arogyaworld.org/diwali_photobooth/api/addphoto.php`,
      body
    );

    if (data?.message === "Photo added successfully.") setLink(true);
    setLoading(false);
  } catch (err) {
    setLoading(false);
  }
};

export const saveSelfie = async ({ body, callback, link }) => {
  try {
    const { data, status } = await axios.post(
      "https://nbrm3t7gl1.execute-api.us-east-1.amazonaws.com/prod/rcsmooth/saveSelfie",
      body
    );
    if (status === 200 && data.status === "SUCCESS") {
      callback({ error: null, link: link });
    } else if (status === 200 && data.status === "FAILURE") {
      callback({ error: data.message, link: null });
    }
  } catch (err) {
    callback({ error: err.message, link: null });
  }
};

export const login = async ({ body, setLoading, callback }) => {
  try {
    const { data } = await axios.post(
      `https://healthywalidiwali.arogyaworld.org/diwali_photobooth/api/loginregister.php`,
      body
    );

    if (data?.user_id) callback(data.user_id);
    else setLoading(false);
  } catch (err) {
    setLoading(false);
  }
};
